/* HOSHIKA · OriKura — comportamento das seções "OK · …"
   1) Botões [data-ok-buy]: rolam até o bloco de kits (Kaching) / formulário do produto.
      Não levam direto ao checkout → o evento AddToCart do pixel dispara normalmente.
   2) [data-ok-countdown]: contagem regressiva até a data real de fim da campanha (JST). Some depois do fim. */
(function () {
  if (window.__okPages) return; /* várias seções carregam este arquivo: roda uma vez só */
  window.__okPages = true;
  function target() {
    var sel = ['kaching-bundle', '.kaching-bundles', '[class*="kaching-bundles"]', '[id^="ProductInfo-"] form[action*="/cart/add"]', 'form[action*="/cart/add"]'];
    for (var i = 0; i < sel.length; i++) { var el = document.querySelector(sel[i]); if (el) return el; }
    return null;
  }
  /* Link "#reviews-app": rola até o widget do app de reviews (aReviews / Judge.me), onde quer que esteja */
  document.addEventListener('click', function (e) {
    var r = e.target.closest('a[href="#reviews-app"]');
    if (!r) return;
    var el = document.querySelector('[id*="areviews"], .areviews, [class*="areviews"], .jdgm-review-widget, .jdgm-widget');
    if (!el) return;
    e.preventDefault();
    window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - 90, behavior: 'smooth' });
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-ok-buy]');
    if (!a) return;
    var t = target();
    if (!t) return; /* sem formulário na página: segue o link normal */
    e.preventDefault();
    var y = t.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: y, behavior: 'smooth' });
  });

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var els = document.querySelectorAll('[data-ok-countdown]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var end = Date.parse(el.getAttribute('data-ok-countdown'));
      if (isNaN(end)) continue;
      var d = end - Date.now();
      var wrap = el.closest('[data-ok-hide-after]');
      if (d <= 0) { if (wrap) wrap.style.display = 'none'; else el.textContent = ''; continue; }
      var s = Math.floor(d / 1000), dd = Math.floor(s / 86400), hh = Math.floor((s % 86400) / 3600), mm = Math.floor((s % 3600) / 60), ss = s % 60;
      el.innerHTML = (dd > 0 ? '<b>' + dd + '日</b>' : '') + '<b>' + pad(hh) + '</b>:<b>' + pad(mm) + '</b>:<b>' + pad(ss) + '</b>';
    }
  }
  if (document.querySelector('[data-ok-countdown]')) { tick(); setInterval(tick, 1000); }
  document.addEventListener('shopify:section:load', tick);
})();
